import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const ColorsSection = () => (
  <section className={styles.section}>
    <SectionHeader
      title="Colors"
      description="Color tokens from the design system. Use CSS custom properties like var(--color-primary-base). Toggle the theme to see light/dark mode variations."
      figmaNodeId="2-462"
      styles={styles}
    />

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Primary</h3>
      <div className={styles.colorGrid}>
        <div className={styles.colorItem}>
          <div className={styles.colorSwatch} style={{ backgroundColor: 'var(--color-primary-base)' }} />
          <span className={styles.colorName}>Primary Base</span>
          <code className={styles.colorCode}>--color-primary-base</code>
        </div>
        <div className={styles.colorItem}>
          <div className={styles.colorSwatch} style={{ backgroundColor: 'var(--color-primary-light)' }} />
          <span className={styles.colorName}>Primary Light</span>
          <code className={styles.colorCode}>--color-primary-light</code>
        </div>
        <div className={styles.colorItem}>
          <div className={styles.colorSwatch} style={{ backgroundColor: 'var(--color-primary-dark)' }} />
          <span className={styles.colorName}>Primary Dark</span>
          <code className={styles.colorCode}>--color-primary-dark</code>
        </div>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-primary-on-primary)' }}
          />
          <span className={styles.colorName}>On Primary</span>
          <code className={styles.colorCode}>--color-primary-on-primary</code>
        </div>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Secondary</h3>
      <div className={styles.colorGrid}>
        <div className={styles.colorItem}>
          <div className={styles.colorSwatch} style={{ backgroundColor: 'var(--color-secondary-base)' }} />
          <span className={styles.colorName}>Secondary Base</span>
          <code className={styles.colorCode}>--color-secondary-base</code>
        </div>
        <div className={styles.colorItem}>
          <div className={styles.colorSwatch} style={{ backgroundColor: 'var(--color-secondary-light)' }} />
          <span className={styles.colorName}>Secondary Light</span>
          <code className={styles.colorCode}>--color-secondary-light</code>
        </div>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Semantic</h3>
      <div className={styles.colorGrid}>
        <div className={styles.colorItem}>
          <div className={styles.colorSwatch} style={{ backgroundColor: 'var(--color-semantic-info)' }} />
          <span className={styles.colorName}>Info</span>
          <code className={styles.colorCode}>--color-semantic-info</code>
        </div>
        <div className={styles.colorItem}>
          <div className={styles.colorSwatch} style={{ backgroundColor: 'var(--color-semantic-warning)' }} />
          <span className={styles.colorName}>Warning</span>
          <code className={styles.colorCode}>--color-semantic-warning</code>
        </div>
        <div className={styles.colorItem}>
          <div className={styles.colorSwatch} style={{ backgroundColor: 'var(--color-semantic-danger)' }} />
          <span className={styles.colorName}>Danger</span>
          <code className={styles.colorCode}>--color-semantic-danger</code>
        </div>
        <div className={styles.colorItem}>
          <div className={styles.colorSwatch} style={{ backgroundColor: 'var(--color-semantic-success)' }} />
          <span className={styles.colorName}>Success</span>
          <code className={styles.colorCode}>--color-semantic-success</code>
        </div>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Semantic Containers</h3>
      <div className={styles.colorGrid}>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-semantic-container-info)' }}
          />
          <span className={styles.colorName}>Container Info</span>
          <code className={styles.colorCode}>--color-semantic-container-info</code>
        </div>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-semantic-container-warning)' }}
          />
          <span className={styles.colorName}>Container Warning</span>
          <code className={styles.colorCode}>--color-semantic-container-warning</code>
        </div>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-semantic-container-danger)' }}
          />
          <span className={styles.colorName}>Container Danger</span>
          <code className={styles.colorCode}>--color-semantic-container-danger</code>
        </div>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-semantic-container-success)' }}
          />
          <span className={styles.colorName}>Container Success</span>
          <code className={styles.colorCode}>--color-semantic-container-success</code>
        </div>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-semantic-container-accent)' }}
          />
          <span className={styles.colorName}>Container Accent</span>
          <code className={styles.colorCode}>--color-semantic-container-accent</code>
        </div>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Text</h3>
      <div className={styles.colorGrid}>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-text-primary)' }}
          />
          <span className={styles.colorName}>Text Primary</span>
          <code className={styles.colorCode}>--color-text-primary</code>
        </div>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-text-secondary)' }}
          />
          <span className={styles.colorName}>Text Secondary</span>
          <code className={styles.colorCode}>--color-text-secondary</code>
        </div>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-text-tertiary)' }}
          />
          <span className={styles.colorName}>Text Tertiary</span>
          <code className={styles.colorCode}>--color-text-tertiary</code>
        </div>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Backgrounds & Surfaces</h3>
      <div className={styles.colorGrid}>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-background-primary)' }}
          />
          <span className={styles.colorName}>Background Primary</span>
          <code className={styles.colorCode}>--color-background-primary</code>
        </div>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-background-alt)' }}
          />
          <span className={styles.colorName}>Background Alt</span>
          <code className={styles.colorCode}>--color-background-alt</code>
        </div>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-surface-primary)' }}
          />
          <span className={styles.colorName}>Surface Primary</span>
          <code className={styles.colorCode}>--color-surface-primary</code>
        </div>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-surface-alt)' }}
          />
          <span className={styles.colorName}>Surface Alt</span>
          <code className={styles.colorCode}>--color-surface-alt</code>
        </div>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Grey Scale</h3>
      <div className={styles.colorGrid}>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-grey-light)' }}
          />
          <span className={styles.colorName}>Grey Light</span>
          <code className={styles.colorCode}>--color-grey-light</code>
        </div>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-grey-soft)' }}
          />
          <span className={styles.colorName}>Grey Soft</span>
          <code className={styles.colorCode}>--color-grey-soft</code>
        </div>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-grey-neutral)' }}
          />
          <span className={styles.colorName}>Grey Neutral</span>
          <code className={styles.colorCode}>--color-grey-neutral</code>
        </div>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-grey-dark)' }}
          />
          <span className={styles.colorName}>Grey Dark</span>
          <code className={styles.colorCode}>--color-grey-dark</code>
        </div>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Border & Neutrals</h3>
      <div className={styles.colorGrid}>
        <div className={styles.colorItem}>
          <div className={styles.colorSwatchWithBorder} style={{ backgroundColor: 'var(--color-border)' }} />
          <span className={styles.colorName}>Border</span>
          <code className={styles.colorCode}>--color-border</code>
        </div>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-neutrals-black)' }}
          />
          <span className={styles.colorName}>Neutrals Black</span>
          <code className={styles.colorCode}>--color-neutrals-black</code>
        </div>
        <div className={styles.colorItem}>
          <div
            className={styles.colorSwatchWithBorder}
            style={{ backgroundColor: 'var(--color-neutrals-white)' }}
          />
          <span className={styles.colorName}>Neutrals White</span>
          <code className={styles.colorCode}>--color-neutrals-white</code>
        </div>
      </div>
    </div>
  </section>
);
